/**
 * Shared presentational page title.
 *
 * The canonical site title: a primary-blue (`#005CA9`) Aleo `<h1>` with a short
 * yellow (`#FFA401`) underline accent, on the white page background. Both
 * `PageHeaderRenderer` and `DataRecordDetailRenderer` render through this
 * component so every inner page — authored or migrated — has an identical
 * header. Keep this the single source of truth for the title look.
 */
export function PageTitle({ title }: { title: string }) {
  return (
    <header className="mb-3 md:mb-4">
      <h1
        className="text-3xl font-semibold md:text-4xl text-[#005CA9]"
        style={{ fontFamily: "var(--font-aleo)" }}
      >
        {title}
      </h1>
      <div className="mt-2 h-1 w-12 rounded-sm bg-[#FFA401]" aria-hidden="true" />
    </header>
  );
}
